import React from 'react'

const NavMobile = ({ lang, setLang, isNavOpen, onClickMenu, navContent, setNavOpen }) => {
    const navMobleStyle = {
        left: isNavOpen ? '0px' : '-100dvw',
    }
    return (
        <div className='nav-mobile' style={navMobleStyle}>
            <button className='nav-mobile-close-btn'
                onClick={(e) => {
                    setNavOpen(false);
                    e.preventDefault();
                }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 20 20" fill="none">
                    <path d="M16.6666 3.3335L3.33325 16.6668" stroke="black" strokeWidth="2" />
                    <path d="M16.6666 16.6665L3.33325 3.33317" stroke="black" strokeWidth="2" />
                </svg>
            </button>
            <button className={`nav-mobile-menu ${navContent === 'about' ? 'active' : ''}`} onClick={(e) => {
                setNavOpen(false);
                e.preventDefault();
                onClickMenu('about');
            }}>ABOUT</button>
            <button className={`nav-mobile-menu ${navContent === 'work' ? 'active' : ''}`} onClick={(e) => {
                setNavOpen(false);
                e.preventDefault();
                onClickMenu('work');
            }}>WORK</button>
            <button className={`nav-mobile-menu ${navContent === 'contact' ? 'active' : ''}`} onClick={(e) => {
                setNavOpen(false);
                e.preventDefault();
                onClickMenu('contact');
            }}>CONTACT</button>
            <div className='nav-mobile-language' onClick={(e) => {
                setNavOpen(false);
                setLang(lang === 'ENG' ? 'KOR' : 'ENG');
                e.preventDefault();
            }}>{lang}</div>
            <div className='nav-mobile-profile'>
                <a href={lang === 'ENG' ? `./data/HNINE_INTERACTION_ENG.pdf` : `./data/HNINE_INTERACTION_KOR.pdf`} download className="profile">
                    <div>PROFILE</div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 20 20" fill="none">
                        <path d="M9.99984 1.6665V14.9998M9.99984 14.9998L3.33325 9.44428M9.99984 14.9998L16.6665 9.44428M3.33336 18.3332L16.6666 18.3332" stroke="black" strokeWidth="1.5" />
                    </svg>
                </a>
            </div>
        </div>
    );
};

export default NavMobile